import { render, staticRenderFns } from "./ProductCategoryManagement.vue?vue&type=template&id=d9a01c3c&scoped=true"
import script from "./ProductCategoryManagement.vue?vue&type=script&lang=js"
export * from "./ProductCategoryManagement.vue?vue&type=script&lang=js"
import style0 from "./ProductCategoryManagement.vue?vue&type=style&index=0&id=d9a01c3c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9a01c3c",
  null
  
)

export default component.exports